const prefix = 'location/';

export const LOCATION_PERMISSION_DENIED = `${prefix}LOCATION_PERMISSION_DENIED` as const;
export const LOCATION_PERMISSION_GRANTED = `${prefix}LOCATION_PERMISSION_GRANTED` as const;
export const LOCATION_TIMEOUT = `${prefix}LOCATION_TIMEOUT` as const;
export const LOCATION_TIMESTAMP_UPDATE = `${prefix}LOCATION_TIMESTAMP_UPDATE` as const;
export const LOCATION_UPDATE = `${prefix}LOCATION_UPDATE` as const;
export const LOCATION_UPDATE_FAILURE = `${prefix}LOCATION_UPDATE_FAILURE` as const;
export const LOCATION_PERMISSION_DISMISS = `${prefix}LOCATION_PERMISSION_DISMISS` as const;

export const LAT_LON_FALLBACK = { lat: 0, lon: 0 };
